/* Maximilian brand behaviors: scroll reveals + ambient video control.
   Fail-safe: without this file, all content is visible and videos autoplay natively. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Altura real minima del viewport (12-oct-2026). Safari iOS, al cargar la portada con la barra del navegador
     recogida, da a 100svh la altura de la pantalla entera y no la corrige despues: el hero de la home (100svh)
     salia mas alto que la vista inicial. Guardamos en --mx-vh-min la altura visible mas pequena observada (se
     reinicia al cambiar la anchura, es decir, al girar el telefono) y el CSS del hero toma el minimo entre 100svh
     y ese valor. Se ignoran alturas menores del 60% de la pantalla (teclado en pantalla en Android). */
  var vhMin = 0;
  var vhAncho = 0;
  var medirVh = function () {
    var w = window.innerWidth;
    var h = window.innerHeight;
    if (!h || (window.screen && window.screen.height && h < window.screen.height * 0.6)) return;
    if (w !== vhAncho) {
      vhAncho = w;
      vhMin = 0;
    }
    if (!vhMin || h < vhMin) {
      vhMin = h;
      document.documentElement.style.setProperty('--mx-vh-min', h + 'px');
    }
  };
  medirVh();
  window.addEventListener('resize', medirVh);
  window.addEventListener('orientationchange', function () {
    setTimeout(medirVh, 350);
  });

  var reveals = document.querySelectorAll('.mx-reveal');
  if (reduced || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) {
      el.classList.add('mx-in');
    });
  } else {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mx-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    reveals.forEach(function (el) {
      io.observe(el);
    });
    // Guarantee: nothing stays hidden even if observation never fires.
    setTimeout(function () {
      reveals.forEach(function (el) {
        el.classList.add('mx-in');
      });
    }, 1800);
  }

  /* Sticky sequence (mobile): statements crossfade by viewport position so
     they are born low, peak at centre, and dissolve BEFORE reaching the
     pinned header (numeral + label). Without JS they simply stay visible. */
  var stickyItems = document.querySelectorAll('.mx-sticky__item p');
  var stickySec = document.querySelector('.mx-sticky');
  if (stickyItems.length && stickySec && !reduced) {
    var fade = function () {
      var vh = window.innerHeight || 1;
      /* INVARIANTE (gobierna SIEMPRE, también en la salida): ninguna frase
         legible puede tocar la cabecera fijada. La frontera se mide en vivo
         sobre la cabecera visible, sea cual sea el viewport. En la salida,
         si la cabecera viaja con la sección (móvil), la frontera viaja con
         ella y la última frase acompaña; si sigue clavada (desktop), la
         frase se funde ante ella. */
      var limite = 0;
      var cabeceras = stickySec.querySelectorAll('.mx-sticky__head, .mx-sticky__ghosthead');
      cabeceras.forEach(function (h) {
        if (h.offsetParent !== null) {
          var hb = h.getBoundingClientRect().bottom;
          if (hb > limite) limite = hb;
        }
      });
      var saliendo = stickySec.getBoundingClientRect().bottom <= vh + 1;
      stickyItems.forEach(function (p) {
        var r = p.getBoundingClientRect();
        var guarda = limite > 0 ? (r.top - limite - 18) / 110 : 1;
        guarda = Math.max(0, Math.min(1, guarda));
        var o;
        if (saliendo) {
          o = guarda;
        } else {
          var c = (r.top + r.bottom) / 2 - vh / 2;
          var d = Math.abs(c) / (vh / 2);
          var curva = c > 0 ? 1.2 - 0.75 * d : 1.15 - 1.2 * d;
          o = Math.min(Math.max(0, Math.min(1, curva)), guarda);
        }
        p.style.opacity = o.toFixed(3);
      });
    };
    window.addEventListener('scroll', fade, { passive: true });
    window.addEventListener('resize', fade);
    fade();
  }

  /* Tech story: anatomía interactiva (marcador <-> fila sincronizados) y
     contadores de datos. Sin JS todo queda visible con valores finales. */
  document.querySelectorAll('[data-mx-techstory]').forEach(function (sec) {
    var markers = sec.querySelectorAll('[data-mx-hotspot]');
    var rows = sec.querySelectorAll('[data-mx-feature]');
    var activar = function (i) {
      var alguno = false;
      markers.forEach(function (m) { m.classList.toggle('mx-active', m.getAttribute('data-mx-hotspot') === i); });
      rows.forEach(function (r) {
        var on = r.getAttribute('data-mx-feature') === i;
        r.classList.toggle('mx-active', on);
        if (on) alguno = true;
      });
      sec.classList.toggle('mx-techstory--dimmed', alguno);
    };
    markers.forEach(function (m) {
      m.addEventListener('click', function () {
        var i = m.getAttribute('data-mx-hotspot');
        var ya = m.classList.contains('mx-active');
        activar(ya ? null : i);
        if (!ya) {
          var fila = sec.querySelector('[data-mx-feature="' + i + '"]');
          if (fila && window.matchMedia('(max-width: 899px)').matches) {
            fila.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
          }
        }
      });
    });
    rows.forEach(function (r) {
      r.addEventListener('click', function () {
        var i = r.getAttribute('data-mx-feature');
        activar(r.classList.contains('mx-active') ? null : i);
      });
    });

    /* Contadores: animan al entrar en pantalla; failsafe fija el valor final */
    var counters = sec.querySelectorAll('[data-mx-count]');
    if (!counters.length) return;
    var fijar = function (el) { el.textContent = el.getAttribute('data-mx-count'); };
    if (reduced || !('IntersectionObserver' in window)) {
      counters.forEach(fijar);
      return;
    }
    var animar = function (el) {
      if (document.hidden) { fijar(el); return; }
      var objetivo = el.getAttribute('data-mx-count');
      var m = objetivo.match(/^([^0-9]*)([0-9]+(?:[.,][0-9]+)?)(.*)$/);
      if (!m) { fijar(el); return; }
      var pre = m[1], fin = parseFloat(m[2].replace(',', '.')), suf = m[3];
      var dec = (m[2].split(/[.,]/)[1] || '').length;
      var t0 = null;
      var paso = function (t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / 1200);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = pre + (fin * e).toFixed(dec) + suf;
        if (p < 1) requestAnimationFrame(paso);
      };
      el.textContent = pre + (0).toFixed(dec) + suf;
      requestAnimationFrame(paso);
      setTimeout(function () { fijar(el); }, 1600);
    };
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animar(entry.target);
          cio.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { cio.observe(c); });
  });

  var videos = document.querySelectorAll('video.mx-ambient-video');
  if (reduced) {
    videos.forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
    });
    return;
  }
  if (!('IntersectionObserver' in window)) return;

  var vio = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    },
    { threshold: 0.15 }
  );
  videos.forEach(function (v) {
    vio.observe(v);
  });
})();

/* ----- Busqueda en la cabecera movil (8-sep-2026) -----
   Pipeline engancha su buscador flotante (search-popdown) solo al PRIMER [data-popdown-toggle] del header.
   El icono movil no lleva ese atributo: delega el toque en el icono de desktop ya enganchado (oculto en movil,
   pero .click() dispara igual su handler). Si el flotante no aparece, se navega a /search como red de seguridad. */
document.addEventListener('click', function (e) {
  var boton = e.target.closest('[data-mx-search-toggle]');
  if (!boton) return;
  var disparador = document.querySelector('[data-popdown-toggle="search-popdown"][aria-controls]');
  if (!disparador) return; /* sin JS de Pipeline: el enlace navega a /search por si solo */
  e.preventDefault();
  disparador.click();
  var destino = boton.getAttribute('href');
  setTimeout(function () {
    var flotante = document.getElementById('search-popdown');
    if (!(flotante && flotante.classList.contains('is-visible')) && destino) window.location.href = destino;
  }, 400);
});

/* ----- Resultados del buscador flotante en movil (8-sep-2026, v2) -----
   Pipeline bloquea el scroll de la pagina mientras el flotante esta abierto y cierra los resultados en cuanto el
   campo pierde el foco (focusout fuera de <predictive-search>). En iPhone, con el teclado abierto, la lista quedaba
   tapada y al intentar desplazarla el teclado se iba... y los resultados con el. Ahora: la lista se marca como zona
   desplazable para scroll-lock, y al desplazarla el foco pasa a la propia lista (dentro de <predictive-search>):
   el teclado se retira, los resultados siguen abiertos a pantalla completa y tocar el campo permite editar. */
(function () {
  var pop = document.getElementById('search-popdown');
  if (!pop) return;
  var input = pop.querySelector('[data-predictive-search-input]');
  function marcar() {
    var r = pop.querySelector('.header__search__results');
    if (r) { r.setAttribute('data-scroll-lock-scrollable', ''); r.setAttribute('tabindex', '-1'); }
  }
  marcar();
  new MutationObserver(marcar).observe(pop, { childList: true, subtree: true });
  function retirarTeclado(e) {
    var lista = e.target.closest('.header__search__results');
    if (lista && input && document.activeElement === input) lista.focus({ preventScroll: true });
  }
  pop.addEventListener('touchmove', retirarTeclado, { passive: true });
  pop.addEventListener('wheel', retirarTeclado, { passive: true });
})();

/* ----- Kbite (Back in Stock) + Pipeline 8.2 (16-sep-2026) -----
   Al cambiar de variante, Pipeline vuelve a pedir la seccion de producto y la "morphea" (Alpine morph):
   cualquier nodo que no venga en el HTML nuevo se borra, y ahi cae el boton "Notify me when available" que
   Kbite inyecta junto al boton de compra (parpadeo, o directamente no aparece segun el orden). El morph de
   Pipeline respeta los elementos con el atributo data-shopify (DEFAULT_MORPH_CONFIG: updating/removing -> skip),
   asi que basta con marcar el boton de Kbite en cuanto aparece. Sin Kbite, este bloque no hace nada. */
(function () {
  var SEL = '.gw-button-widget';
  function marcar(raiz) {
    if (!raiz || raiz.nodeType !== 1) return;
    var lista = raiz.matches(SEL) ? [raiz] : raiz.querySelectorAll(SEL);
    for (var i = 0; i < lista.length; i++) {
      if (!lista[i].hasAttribute('data-shopify')) lista[i].setAttribute('data-shopify', '');
    }
  }
  marcar(document.body);
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var a = ms[i].addedNodes;
      for (var j = 0; j < a.length; j++) marcar(a[j]);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

/* ----- Pestañas perezosas en "Product slider tabs" (23-sep-2026) -----
   Fuera del editor, la seccion solo trae en el HTML los productos de la primera pestaña; las demas llevan una
   <template> con la cabecera del carrusel (ver sections/section-collection-tabs.liquid). Al pasar por la pestaña o
   pulsarla se piden sus tarjetas a /collections/<handle>?section_id=api-collection-tab, se meten en la cabecera
   clonada y se cuelgan en la pestaña: <flickity-carousel> es un custom element del tema y se inicializa solo al
   conectarse (y se redimensiona con theme:tab:change, como las pestañas normales). Si falla, queda un enlace a la
   coleccion. */
(function () {
  var secciones = document.querySelectorAll('[data-mx-lazy-tabs]');
  if (!secciones.length || !('fetch' in window) || !('content' in document.createElement('template'))) return;
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function cargar(tab, boton) {
    if (!tab || tab.getAttribute('data-mx-estado')) return;
    tab.setAttribute('data-mx-estado', 'cargando');
    var handle = tab.getAttribute('data-mx-collection');
    var limite = parseInt(tab.getAttribute('data-mx-limit'), 10) || 20;
    var urlColeccion = raiz + 'collections/' + handle;
    fetch(urlColeccion + '?section_id=api-collection-tab', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var slides = Array.prototype.slice.call(doc.querySelectorAll('[data-api-content] > [data-carousel-slide]'), 0, limite);
        var plantilla = tab.querySelector('template[data-mx-carousel-shell]');
        if (!plantilla || !slides.length) throw new Error('sin tarjetas');
        var frag = document.importNode(plantilla.content, true);
        var carrusel = frag.querySelector('[data-carousel]');
        for (var i = 0; i < slides.length; i++) carrusel.appendChild(document.importNode(slides[i], true));
        var esqueleto = tab.querySelector('.mx-lazy-tab__skeleton');
        if (esqueleto) esqueleto.remove();
        plantilla.remove();
        tab.appendChild(frag);
        tab.setAttribute('data-mx-estado', 'cargado');
      })
      .catch(function () {
        tab.removeAttribute('data-mx-estado');
        var esqueleto = tab.querySelector('.mx-lazy-tab__skeleton');
        if (esqueleto && !esqueleto.querySelector('a')) {
          var texto = boton ? boton.textContent.trim() : handle;
          esqueleto.innerHTML = '<a class="mx-lazy-tab__fallback" href="' + urlColeccion + '">' + texto + '</a>';
        }
      });
  }

  secciones.forEach(function (sec) {
    sec.querySelectorAll('.tab-link').forEach(function (boton) {
      var idx = boton.getAttribute('data-tab');
      var tab = sec.querySelector('.tab-content-' + idx + '[data-mx-lazy-tab]');
      if (!tab) return;
      var pre = function () { cargar(tab, boton); };
      boton.addEventListener('pointerenter', pre);
      boton.addEventListener('touchstart', pre, { passive: true });
      boton.addEventListener('focus', pre);
      boton.addEventListener('click', pre);
    });
  });
})();

/* PDP: anade el color del titulo "Nombre (Color)" junto a la etiqueta "Color" de la app de swatches, como hacen las leyendas Grip / Size */
(function () {
  function poner() {
    var raiz = document.querySelector('[data-mx-colour-name]');
    var app = document.querySelector('webyze-linkify-product-colors');
    if (!raiz || !app) return false;
    var label = app.querySelector('label');
    if (!label) return false;
    if (label.querySelector('.mx-colour-value')) return true;
    var nombre = (raiz.getAttribute('data-mx-colour-name') || '').trim();
    if (!nombre) return true;
    var span = document.createElement('span');
    span.className = 'mx-colour-value';
    span.textContent = nombre;
    label.appendChild(span);
    return true;
  }
  if (poner()) return;
  var obs = new MutationObserver(function () { if (poner()) obs.disconnect(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 15000);
})();

/* Carruseles de productos (Flickity): la app Linkify inyecta los swatches despues de que Flickity haya medido las
   tarjetas, asi que el visor se queda corto y corta titulo y precio (visto en "You might also like", 23-oct-2026).
   Cuando una tarjeta crece dentro de un carrusel, se vuelve a medir. */
(function () {
  if (!('ResizeObserver' in window)) return;
  var timer = null;
  function remedir() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.querySelectorAll('flickity-carousel').forEach(function (fc) {
        var inst = fc.carouselInstance;
        if (inst && typeof inst.resize === 'function') inst.resize();
      });
    }, 120);
  }
  var ro = new ResizeObserver(remedir);
  function vigilar(root) {
    (root.querySelectorAll ? root.querySelectorAll('flickity-carousel .product-grid-slide') : []).forEach(function (s) { ro.observe(s); });
  }
  vigilar(document);
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'WEBYZE-LINKIFY-PRODUCT-COLORS' || n.querySelector('webyze-linkify-product-colors')) remedir();
        vigilar(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
